
import { Component, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '../../store/modules/user';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import DialogSetImport from '../staff/components/setImport.vue';
import {
  getBrandList,
  addDeviceBrand,
  editDeviceBrand,
  deleteDeviceBrand,
  addDeviceProduct,
  editDeviceProduct,
  deleteDeviceProduct,
  addDeviceModel,
  editDeviceModel,
  deleteDeviceModel,
  batchDeleteBrand
} from '@/api/device';
import { makeKey } from '@/utils/qiniu';
import { getQiniuToken } from '../../api/third';
import { Qiniu } from '@/types/qiniu';
import { regular } from '@/const/regular';
import Sortable from 'sortablejs';

@Component({
  name: 'DeviceToBrand',
  components: {
    DialogImgLarge,
    DialogSetImport,
  }
})
export default class extends Vue {
  private formSearch: any = {
    name: ''
  };
  private listQuery = {
    name: '',
    product_type: '1',
    brand_id: '',
    product_id: ''
  };
  private qiniu: any;
  private action = 'https://up-z1.qiniup.com';
  private form: object = {};

  private regular = regular;
  private rules = {
    name: [
      {
        required: true,
        message: "请输入1-30个字符组成的名称；不支持：'、\"、",
        trigger: 'blur'
      },
      {
        pattern: regular.devideName.pattern,
        message: "请输入1-30个字符组成的名称；不支持：'、\"、",
        trigger: 'blur'
      }
    ]
  };
  // private isDraggable = false
  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private labelBrand='品牌';
  private labelProduct='类型'
  private labelModel='型号'

  created() {
    if (UserModule.company && UserModule.company.brand_name_alias) {
      this.labelBrand = UserModule.company.brand_name_alias;
      this.setImportTitle = '导入' + this.labelBrand;
    } else {
      this.labelBrand = '品牌';
      this.setImportTitle = '导入品牌';
    }
    if (UserModule.company && UserModule.company.product_name_alias) {
      this.labelProduct = UserModule.company.product_name_alias;
    } else {
      this.labelProduct = '类型';
    }
    if (UserModule.company && UserModule.company.model_name_alias) {
      this.labelModel = UserModule.company.model_name_alias;
    } else {
      this.labelModel = '型号';
    }
    const params = {
      type: Qiniu.UPLOAD_TYPE_BRAND
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
    this.getBrandList();
  }

  resetData() {
    this.formSearch = {
      name: ''
    };
    this.handleSearch();
  }

  handleSearch() {
    this.pagination.currentPage = 1
    this.listQuery = {
      name: this.formSearch.name,
      product_type: '1',
      brand_id: '',
      product_id: ''
    };
    this.getBrandList();
  }

  handleClear() {
    this.resetData();
  }

  resetListQuery(product_type: any,brand_id: any,product_id: any){
    this.listQuery.product_type = product_type;
    this.listQuery.brand_id = brand_id;
    this.listQuery.product_id = product_id;
  }
  // private sortHandle() {
  //   this.isDraggable = true;
  //   var sortable = new Sortable((this.$refs.tableData as any).$el.querySelector('.el-table__body > tbody'), {
  //     animation: 350,
  //     onEnd: function(/** Event */evt: any) {
  //       var itemEl = evt.item; // dragged HTMLElement
  //     },
  //   })
  // }
  // private sortConfirm() {
  //   this.isDraggable = false
  // }

  private expands: any = [];
  private expands1: any = [];

  firstExpand(val: any, row: any, lev: any) {
    let arr = row.filter((rrr: any) => {
      return val.id === rrr.id;
    });
    if (arr && arr.length > 0) {
      if (lev === 2) {
        this.expands.push(val.id);
        if (row) {
          this.listQuery.product_type = lev;
          this.listQuery.brand_id = val.id;
        }
      }
      if (lev === 3) {
        this.expands1.push(val.id);
        if (row) {
          this.listQuery.product_type = lev;
          this.listQuery.product_id = val.id;
        }
      }
      this.getBrandList();
    } else {
      if (lev === 2) {
        var index = this.expands.indexOf(val.id);
        if (index > -1) {
          this.expands.splice(index, 1);
        }
      }
      if (lev === 3) {
        var index1 = this.expands1.indexOf(val.id);
        if (index1 > -1) {
          this.expands1.splice(index1, 1);
        }
      }
    }
  }

  getBrandList() {
    const params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      ...this.listQuery
    };
    if (parseInt(this.listQuery.product_type) === 1) {
      params.page = this.pagination.currentPage
      params.size = this.pagination.pageSize
    } else {
      params.page = 1
      params.size = 9999
    }
    getBrandList(params)
      .then((res) => {
        this.dealData(this.listQuery.product_type, res);
      })
      .catch((err) => {
        this.dealData(this.listQuery.product_type, []);
        let msg = err.msg;
      });
  }

  private dealData(type: any, res: any) {
    var listData = [];
    if (res && res.data) {
      if (parseInt(this.listQuery.product_type) === 1) {
        this.pagination.total = res.data.count;
      }
      listData = res.data.list;
    }
    switch (parseInt(this.listQuery.product_type)) {
      case 1:
        this.tableData = listData;
        break;
      case 2:
        for (var i = 0; i < this.tableData.length; i++) {
          var temp = this.tableData[i];
          if ((temp as any).id === this.listQuery.brand_id) {
            (temp as any).child = listData;
            this.$set(this.tableData, i, temp);
          }
        }
        break;
      case 3:
        for (var m = 0; m < this.tableData.length; m++) {
          var t: any = this.tableData[m];
          if (t.id === this.listQuery.brand_id) {
            for (var n = 0; n < t.child.length; n++) {
              var tt: any = t.child[n];
              if (tt.id === this.listQuery.product_id) {
                tt.child = listData;
                this.$set((this.tableData[m] as any).child, n, tt);
              }
            }
          }
        }
        break;
    }
  }

  private close() {
    this.dialogAddBrandVisible = false;
    this.formAddBrand = {
      name: '',
      imageUrl: '',
      imageUrlKey: '',
      brand_id: '',
      sort: 100
    };
    (this.$refs['formAddBrand'] as any).resetFields();
  }

  private addBrandHandle() {
    this.dialogAddBrandVisible = true;
  }

  // 导入品牌
  private setImportVisible = false
  private setImportTitle = '导入品牌'
  private importBrandHandle() {
    this.setImportVisible = true;
  }
  private closeImport(val: any) {
    this.setImportVisible = val;
  }

  // 删除品牌
  private deleteBrand(val: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          brand_id: val.id
        };
        deleteDeviceBrand(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            //刷新一级列表
            this.resetListQuery('1','','');
            this.getBrandList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  // 编辑品牌
  private editBrand(val: any) {
    this.dialogAddBrandVisible = true;
    this.formAddBrand = {
      name: val.name,
      imageUrl: val.image_save_path,
      imageUrlKey: val.short_save_path,
      brand_id: val.id,
      sort: val.sort
    };
  }

  // 添加品牌
  private addBrand(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          brand_name: this.formAddBrand.name,
          name: this.formAddBrand.name,
          image_save_path: this.formAddBrand.imageUrlKey,
          brand_id: '',
          sort: this.formAddBrand.sort
        };
        if (this.formAddBrand.brand_id) {
          params.brand_id = this.formAddBrand.brand_id;
          editDeviceBrand(params)
            .then((res) => {
              this.close();
              this.showSuccessMsg('修改成功');
              //刷新一级列表
              this.resetListQuery('1','','');
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          addDeviceBrand(params)
            .then((res) => {
              this.close();
              this.showSuccessMsg('添加成功');
              //刷新一级列表
              this.resetListQuery('1','','');
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        }
        // alert('submit!');
      } else {
        return false;
      }
    });
  }

  private closeType() {
    this.dialogAddTypeVisible = false;
    this.formAddType = {
      brand: '',
      brand_id: '',
      product_id: '',
      name: '',
      imageUrl: '',
      imageUrlKey: '',
      sort: 100
    };
    (this.$refs['formAddType'] as any).resetFields();
  }

  private deleteTypeHandle(val: any, val2: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          product_id: val2.id
        };
        deleteDeviceProduct(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.resetListQuery('2',val.id,val2.id);
            this.getBrandList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  // 列表添加类型
  addTypeHandle(val: any) {
    this.dialogAddTypeVisible = true;
    this.formAddType = {
      brand: val.name,
      brand_id: val.id,
      name: '',
      imageUrl: '',
      imageUrlKey: '',
      product_id: '',
      sort: 100
    };
  }

  // 列表编辑类型
  editTypeHandle(val: any, val2: any) {
    this.dialogAddTypeVisible = true;
    this.formAddType = {
      brand: val.name,
      brand_id: val.id,
      name: val2.name,
      imageUrl: val2.image_save_path,
      imageUrlKey: val2.short_save_path,
      product_id: val2.id,
      sort: val2.sort
    };
  }

  // 添加/编辑类型
  private addType(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          brand_id: this.formAddType.brand_id,
          product_name: this.formAddType.name,
          name: this.formAddType.name,
          image_save_path: this.formAddType.imageUrlKey,
          product_id: '',
          sort: this.formAddType.sort
        };
        if (this.formAddType.product_id) {
          params.product_id = this.formAddType.product_id;
          editDeviceProduct(params)
            .then((res) => {
              this.closeType();
              this.showSuccessMsg('修改成功');
              this.resetListQuery('2',params.brand_id,params.product_id);
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          addDeviceProduct(params)
            .then((res) => {
              this.closeType();
              this.showSuccessMsg('添加成功');
              //刷新类型
              this.resetListQuery('2',params.brand_id,params.product_id);
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        }
        // alert('submit!');
      } else {
        return false;
      }
    });
  }

  private closeMode() {
    this.dialogAddModelVisible = false;
    this.formAddModel = {
      brand: '',
      brand_id: '',
      product_id: '',
      product: '',
      model_id: '',
      name: '',
      imageUrl: '',
      imageUrlKey: '',
      sort: 100
    };
    (this.$refs['formAddModel'] as any).resetFields();
  }

  /**
   * 追加注释
   * val 品牌
   * val2 产品
   * val3 型号
   */
  private deleteModelHandle(val: any, val2: any, val3: any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          model_id: val3.id
        };
        deleteDeviceModel(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.resetListQuery('3',val.id,val2.id);
            this.getBrandList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private addModelHandle(val: any, val2: any) {
    this.dialogAddModelVisible = true;
    this.formAddModel = {
      brand: val.name,
      brand_id: val.id,
      product_id: val2.id,
      product: val2.name,
      model_id: '',
      name: '',
      imageUrl: '',
      imageUrlKey: '',
      sort: 100
    };
  }

  // 列表编辑类型
  private editModelHandle(val: any, val2: any, val3: any) {
    this.dialogAddModelVisible = true;
    this.formAddModel = {
      brand: val.name,
      brand_id: val.id,
      product_id: val2.id,
      product: val2.name,
      model_id: val3.id,
      name: val3.name,
      imageUrl: val3.image_save_path,
      imageUrlKey: val3.short_save_path,
      sort: val3.sort
    };
  }

  // 添加/编辑类型
  private addModel(formName: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          brand_id: this.formAddModel.brand_id,
          product_id: this.formAddModel.product_id,
          model_name: this.formAddModel.name,
          name: this.formAddModel.name,
          image_save_path: this.formAddModel.imageUrlKey,
          model_id: '',
          sort: this.formAddModel.sort
        };
        if (this.formAddModel.model_id) {
          params.model_id = this.formAddModel.model_id;
          editDeviceModel(params)
            .then((res) => {
              this.closeMode();
              this.showSuccessMsg('修改成功');
              this.resetListQuery('3',params.brand_id,params.product_id);
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        } else {
          addDeviceModel(params)
            .then((res) => {
              this.closeMode();
              this.showSuccessMsg('添加成功');
              this.resetListQuery('3',params.brand_id,params.product_id);
              this.getBrandList();
            })
            .catch((err) => {
              this.showErrorMsg(err.msg);
            });
        }
        // alert('submit!');
      } else {
        return false;
      }
    });
  }

  private batchDeleteBrand() {
    if (this.selectedbox.length < 1) {
      this.showErrorMsg('请选择' + this.labelBrand);
      return;
    }
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        var temp = '';
        for (var data of this.selectedbox) {
          temp += (data as any).id + ',';
        }
        temp = temp.substr(0, temp.length - 1);
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          brand_id: temp
        };
        batchDeleteBrand(params)
          .then((res) => {
            this.isIndeterminate = false;
            this.showSuccessMsg('删除成功');
            //刷新一级列表
            this.resetListQuery('1','','');
            //清空选中的品牌
            this.selectedbox = [];
            this.getBrandList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }

  private tableData = [];
  private selectedbox = [];
  private checkAll = false;
  private isIndeterminate: any = null;
  private dialogAddBrandVisible = false;
  private formAddBrand = {
    name: '',
    imageUrl: '',
    imageUrlKey: '',
    brand_id: '',
    sort: 100
  };
  private dialogAddTypeVisible = false;
  private formAddType = {
    brand: '',
    brand_id: '',
    product_id: '',
    name: '',
    imageUrl: '',
    imageUrlKey: '',
    sort: 100
  };
  private dialogAddModelVisible = false;
  private formAddModel = {
    brand: '',
    brand_id: '',
    product_id: '',
    product: '',
    model_id: '',
    name: '',
    imageUrl: '',
    imageUrlKey: '',
    sort: 100
  };

  handleSelectionChange(value: any) {
    let checkedCount = value.length;
    this.checkAll = checkedCount === this.tableData.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.tableData.length;
  }

  // 全选
  handleCheckAllChange(val: boolean) {
    this.selectedbox = val ? this.tableData : [];
    this.isIndeterminate = false;
  }

  handlePageSizeChange(val: number) {
    this.listQuery = {
      name: '',
      product_type: '1',
      brand_id: '',
      product_id: ''
    }
    this.pagination.pageSize = val;
    this.getBrandList();
  }
  handleCurrentChange(val: number) {
    this.listQuery = {
      name: '',
      product_type: '1',
      brand_id: '',
      product_id: ''
    }
    this.pagination.currentPage = val;
    this.getBrandList();
  }

  AddBrandImageUpSuccess(res: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formAddBrand.imageUrl = imgUrl;
    this.formAddBrand.imageUrlKey = res.key;
  }

  AddTypeImageUpSuccess(res: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formAddType.imageUrl = imgUrl;
    this.formAddType.imageUrlKey = res.key;
  }

  AddModelImageUpSuccess(res: any) {
    const imgUrl = this.qiniu.default_url + res.key;
    this.formAddModel.imageUrl = imgUrl;
    this.formAddModel.imageUrlKey = res.key;
  }

  beforeAddBrandImageUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise<void>((resolve, reject) => {
      resolve();
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.form = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private deleteImgHandle(val:any) {
    this.formAddBrand.imageUrl = '';
    this.formAddBrand.imageUrlKey = '';
    this.formAddType.imageUrl = '';
    this.formAddType.imageUrlKey = '';
    this.formAddModel.imageUrl = '';
    this.formAddModel.imageUrlKey = '';
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
